import { onDisplay } from "../helpers/support";
import { getSingleInstanceByName } from "../../core";
import { getOffset } from "../helpers/html-utils";

export default class GridStackys {
  private stackys: HTMLElement[] = [];
  private grid: HTMLElement;
  private delta = 20;
  private headerSticky = false;
  private headerBottom = 0;
  private header = document.querySelector("header");
  private active = window.innerWidth > 767;
  private topInParent: number[];
  private positions: number[];
  private heights: number[];
  private bottomInParent: number[];
  private height = -30;
  private headerHeight: number;
  private scrollStart: number;
  private scrollEnd: number;
  private stickMobile: boolean;

  constructor(
    elements: HTMLElement[],
    grid: HTMLElement,
    sides: HTMLElement[]
  ) {
    if (elements.length) {
      this.stackys.push(elements[0]);
    }
    for (let i = 1; i < elements.length; i++) {
      elements[i].removeAttribute("data-grid-stack");
    }
    const idx = sides.indexOf(elements[0]);
    for (let j = idx + 1; j < sides.length; j++) {
      this.stackys.push(sides[j]);
    }
    this.grid = grid;
    const sta = document.querySelector("header [data-stacky]");
    if (!sta) {
      const sti = document.querySelector("[data-sticky]") as HTMLElement;
      if (sti) {
        this.header = sti;
      }
    }
    this.init();
  }
  init(): void {
    this.reload();
    window.addEventListener("scroll", () => {
      if (this.active) this.stack();
    });
    window.addEventListener("resize", () => {
      if (this.active) this.stack();
    });
    onDisplay(
      this.grid,
      () => {
        this.active = window.innerWidth > 767;
      },
      () => {
        this.active = false;
      }
    );

    const dataStackyInstance = getSingleInstanceByName("DataStacky");
    if (dataStackyInstance) {
      PubSub.subscribe("dataStacky-change", () => {
        if (this.active) {
          this.headerSticky = dataStackyInstance.sticky;
          this.reload();
        }
      });
    }
    const dataStickyInstance = getSingleInstanceByName("DataSticky");
    if (dataStickyInstance) {
      PubSub.subscribe("dataSticky-change", () => {
        if (this.active) {
          this.headerSticky = dataStickyInstance.sticky;
          this.reload();
        }
      });
    }
  }
  reload(): void {
    const parentOffset = getOffset(this.grid);
    let tmpP = this.delta;
    let margin = 30;
    this.topInParent = this.topInParent || [];
    this.positions = this.positions || [];
    this.heights = this.heights || [];
    this.bottomInParent = this.bottomInParent || [];
    this.height = -30;

    for (let k = 0; k < this.stackys.length; k++) {
      if (
        this.positions.length > 0 &&
        this.stackys[k].style.position === "fixed"
      )
        continue;

      const off = getOffset(this.stackys[k]);
      this.topInParent[k] = (off.top - parentOffset.top) || 0;
      this.heights[k] = off.bottom - off.top;
      if (this.stackys[k].classList.contains("sheet")) {
        margin = 0;
      }
      if (this.stackys[k].classList.contains("endsheet")) {
        margin = 30;
      }
      this.height += (off.bottom - off.top) + margin;
      this.bottomInParent[k] = 0;
      this.positions[k] = tmpP;
      tmpP += (margin + (off.bottom - off.top));
    }
    let tmpH = 0;
    for (let l = this.stackys.length - 1; l > -1; l--) {
      this.bottomInParent[l] = tmpH;
      // we are in the backloop
      if (this.stackys[l].classList.contains("sheet")) {
        margin = 30;
      }
      if (this.stackys[l].classList.contains("endsheet")) {
        margin = 0;
      }
      tmpH += margin + this.heights[l];
    }
    const hOff = getOffset(this.header);
    this.headerHeight = hOff.height;

    const eloffest = getOffset(this.stackys[0]);
    this.scrollStart =
      this.scrollStart !== undefined &&
      this.stackys[0].style.position === "fixed"
        ? this.scrollStart
        : eloffest.top - (this.delta + this.headerHeight) + window.scrollY;
    this.scrollEnd =
      (this.scrollEnd !== undefined && this.stackys[0].style.position === "fixed")
        ? this.scrollEnd
        : parentOffset.bottom -
          (this.height + this.headerHeight + this.delta) +
          window.scrollY;
  }
  stack(): void {
    if (window.innerWidth < 767) {
      if (!this.stickMobile) {
        this.stickMobile = true;
        for (const stacky of this.stackys) {
          stacky.classList.add("noside");
          stacky.style.position = "relative";
          stacky.style.top = "initial";
          stacky.style.bottom = "initial";
          stacky.style.display = "flex";
        }
      }
    } else {
      if (this.active) {
        if (this.stickMobile) {
          this.stickMobile = false;
          for (const stacky of this.stackys) {
            stacky.classList.remove("noside");
          }
        }
        if (window.scrollY >= (this.scrollStart)) {
          if (window.scrollY >= this.scrollEnd) {
            for (let i = 0; i < this.stackys.length; i++) {
              this.stackys[i].style.position = "absolute";
              this.stackys[i].style.bottom = this.bottomInParent[i] + "px";
              this.stackys[i].style.top = "initial";
              this.stackys[i].style.marginBottom = "0";
            }
          } else {
            for (let i = 0; i < this.stackys.length; i++) {
              this.stackys[i].style.position = "fixed";
              this.stackys[i].style.top =
                (this.positions[i] + this.headerHeight) + "px";
              this.stackys[i].style.bottom = "initial";
            }
          }
        } else {
          for (let i = 0; i < this.stackys.length; i++) {
            this.stackys[i].classList.remove("stacky");
            this.stackys[i].style.position = "absolute";
            this.stackys[i].style.top = this.topInParent[i] + "px";
            this.stackys[i].style.bottom = "initial";
          }
        }
      }
    }
  }
}
